<template>
  <div class="bluefire-wap-wrap">
    <wap-header header-text="昆仑数据信息平台" :header-visible="true" :back-visible="false" :user-list-lock.sync="userListLock" :menu.sync="menu" controller="h5" action="tools"/><!--参数都可以不传-->
    <scroll-refresh>
      <div class="tools-wrap">
        <div class="banner-area">
          <img src="../../assets/wap/banner-tools.png" alt=""/>
        </div>
        <div class="title-area">工作台</div>
        <div class="tools-list">
          <div class="btn-area" v-for="item in menu" :key="item.title">
            <a :href="item.href" :state-key="`fib.jiemo.net/h5/tools/button-${item.title}`" :state-status="true">
              <img :src="item.img" alt="">
              <span>{{ item.title }}<i v-show="item.isNew"></i></span>
            </a>
          </div>
        </div>
      </div>
    </scroll-refresh>
  </div>
</template>
<script>
import header from './compoments/header';
import scrollRefresh from './compoments/scrollRefresh';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      messageCount: false,
      readTimer: null,
      userListLock: true,
      menu: [],
    };
  },
  computed: {
    ...mapState(['messageAmount']),
  },
  methods: {
    fetchCount() {
      return this.$http._get({
        url: '/index/system/noRead'
      })
        .then(({ data }) => {
          if (data.behaviour_message || data.consult_message || data.payment_message || data.question_message || data.status_message) {
            this.messageCount = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    userListLock(v) {
      if (!v) {
        this.fetchCount();
      }
    },
    menu: {
      handler: function (menu) {
        if (menu.length) {
          menu.forEach((item) => {
            // eslint-disable-next-line
            item.img = require(`../../assets/wap/icon-${item.title}.png`);
            item.isNew = false;
            if (item.title === '消息通知') {
              item.isNew = this.messageCount;
            }
          });
        }
        return menu;
      },
      deep: true
    }
  },
  destroyed() {
    localStorage.setItem('noreadTimer', true);
  },
  mounted() {},
  components: {
    'wap-header': header,
    scrollRefresh,
  }
};
</script>
<style scoped>
  .bluefire-wap-wrap{
    background: #fff;
  }
  .tools-wrap{
    padding: 0 4vw;
  }
  .tools-wrap .banner-area{
    width: 100%;
  }
  .tools-wrap .banner-area img{
    display: block;
    width: 100%;
  }
  .tools-wrap .title-area{
    font-size: 4.5vw;
    font-weight: bold;
    padding: 7vw 0;
  }
  .tools-wrap .tools-list{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .tools-wrap .tools-list .btn-area{
    display: inline-block;
    width: 28.26vw;
    border-radius: 1.5vw;
    box-shadow: 0px 0px 8px rgba(146, 146, 146, 0.25);
    margin-right: 3.6vw;
    text-align: center;
    margin-bottom: 3.6vw;
  }
  .tools-wrap .tools-list .btn-area:nth-of-type(3n){
    margin-right: 0;
  }
  .tools-wrap .tools-list .btn-area img{
    display: block;
    margin: 4vw auto 2.4vw;
    width: 12vw;
  }
  .tools-wrap .tools-list .btn-area span{
    font-size: 3.73vw;
    color: #333;
    display: inline-block;
    padding-bottom: 4vw;
    position: relative;
  }
  .tools-wrap .tools-list .btn-area span i{
    position: absolute;
    right: -1.6vw;
    top: -0.3vw;
    width: 1.6vw;
    height: 1.6vw;
    border-radius: 100%;
    background: #FF3A3A;
  }
</style>
